// A lease owns delivery lifetime, never access. The server authorizes every join.
const sockets = new WeakMap();

function stateFor(socket) {
  let state = sockets.get(socket);
  if (state) return state;
  state = { identity: null, rooms: new Map() };
  sockets.set(socket, state);
  const join = (room) => socket.emit('addPlayerToGalaxyChat', {
    galaxyId: room.galaxyId, playerId: room.playerId,
  });
  state.join = join;
  const onConnect = () => {
    state.rooms.forEach((room) => {
      if (room.revoked) return;
      join(room);
      room.consumers.forEach((consumer) => consumer.onReconnect?.());
    });
  };
  const onRevoked = ({ galaxyId } = {}) => {
    state.rooms.forEach((room) => {
      if (room.galaxyId !== galaxyId) return;
      room.revoked = true;
      room.consumers.forEach((consumer) => consumer.onRevoked?.());
    });
  };
  socket.on('connect', onConnect);
  socket.on('galaxyChatAccessRevoked', onRevoked);
  state.dispose = () => {
    socket.off('connect', onConnect);
    socket.off('galaxyChatAccessRevoked', onRevoked);
    if (sockets.get(socket) === state) sockets.delete(socket);
  };
  return state;
}

export function setGalaxyChatIdentity(socket, identity) {
  const state = stateFor(socket);
  if (state.identity === identity) return;
  state.identity = identity;
  const previous = [...state.rooms.values()];
  state.rooms.clear();
  previous.forEach((room) => {
    room.revoked = true;
    socket.emit('leaveGalaxyChat', { galaxyId: room.galaxyId, playerId: room.playerId });
    room.consumers.forEach((consumer) => consumer.onRevoked?.());
  });
  if (!identity || identity === ':') state.dispose();
}

export function acquireGalaxyChat({ socket, galaxyId, playerId, token, onRevoked, onReconnect }) {
  if (!socket || !galaxyId || !playerId) return () => {};
  setGalaxyChatIdentity(socket, `${playerId}:${token || ''}`);
  const state = stateFor(socket);
  const key = `${playerId}:${galaxyId}`;
  let room = state.rooms.get(key);
  if (!room || room.revoked) {
    room = { galaxyId, playerId, consumers: new Set(), revoked: false };
    state.rooms.set(key, room);
    state.join(room);
  }
  const consumer = { onRevoked, onReconnect };
  room.consumers.add(consumer);
  let released = false;
  return () => {
    if (released) return;
    released = true;
    room.consumers.delete(consumer);
    if (room.consumers.size || state.rooms.get(key) !== room) return;
    state.rooms.delete(key);
    socket.emit('leaveGalaxyChat', { galaxyId, playerId });
    if (!state.rooms.size) state.dispose();
  };
}
